import React, { useEffect, useRef, useState } from 'react'
import { useInView } from 'motion/react'
import { twMerge } from 'tailwind-merge'

interface AnimatedCounterProps {
    to: number
    duration?: number
    className?: string
    suffix?: string
}

export const AnimatedCounter = ({ to, duration = 2, className, suffix = '' }: AnimatedCounterProps) => {
    const ref = useRef<HTMLSpanElement>(null)
    const isInView = useInView(ref, { once: true, margin: '-80px' })
    const [count, setCount] = useState(0)

    useEffect(() => {
        if (!isInView) return
        let rafId: number
        let startTime: number | null = null
        const step = (timestamp: number) => {
            if (startTime === null) startTime = timestamp
            const elapsed = (timestamp - startTime) / 1000
            const progress = Math.min(elapsed / duration, 1)
            const eased = 1 - Math.pow(1 - progress, 3)
            setCount(Math.floor(eased * to))
            if (progress < 1) rafId = requestAnimationFrame(step)
            else setCount(to)
        }
        rafId = requestAnimationFrame(step)
        return () => cancelAnimationFrame(rafId)
    }, [isInView, to, duration])

    return (
        <span ref={ref} className={twMerge('font-inter tabular-nums', className)}>
            {count.toLocaleString('en-IN')}{suffix}
        </span>
    )
}
